import React from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { update } from "../../utils/apiService";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";

// actions
import { updateVideo } from "../../actions";

class ExpirationDateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disbled: false,
      startDate: moment()
    };

    this.handleChange = this.handleChange.bind(this);
    this.updateExpirationDate = this.updateExpirationDate.bind(this);
  }
  handleChange(date) {
    this.setState({
      startDate: date
    });
  }
  async updateExpirationDate() {
    const { video, sendingId, updateVideo } = this.props;
    let ISODate = moment(this.state.startDate).toISOString();
    let url = `/campaigns/${video.campaign_id}/videos/${
      video.id
    }/sendings/${sendingId}/set_expiration_date`;
    let data = {
      expiration_date: ISODate
    };
    try {
      toastr.info("Atualizando data de expiração");
      let response = await update(url, data);
      let updatedVideo = response.data;
      updateVideo(video.campaign_id, updatedVideo);
      toastr.success("Data de expiração atualizada com sucesso!");
    } catch (err) {
      toastr.error("Ocorreu um erro ao atualizar data de expiração.");
    }
  }
  render() {
    let { show, close, video } = this.props;
    return (
      <Modal show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>Data de expiração</Modal.Title>
        </Modal.Header>
        <Modal.Body className="clearfix">
          <p>Escolha a data de expiração</p>
          <DatePicker
            selected={this.state.startDate}
            onChange={this.handleChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-link"
            onClick={() => {
              this.props.close();
            }}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            disabled={this.state.disabled}
            onClick={() => {
              this.updateExpirationDate();
            }}
          >
            Enviar
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

export default connect(null, mapDispatchToProps)(ExpirationDateModal);



// WEBPACK FOOTER //
// ./src/components/modals/ExpirationDateModal.js